import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>
        通信が不安定、または端末の処理が追いついていない可能性があります。通信環境を確認の上、再度お試しください。
      </p>
    </div>
    <div>
      <p className={styles.heading}>【解決しない場合】</p>
      <p className={styles.text}>
        当ページ下部の
        <a className={styles.link} href="#contact">
          お問い合わせフォーム
        </a>
        より以下を記載の上、ご連絡ください。
      </p>
      <ul className={styles.list}>
        <li className={styles.item}>ご利用のスマートフォンのOS</li>
        <li className={styles.item}>使用しているブラウザ</li>
      </ul>
    </div>
  </div>
);

export const SMARTPHONE_OPERATION_UNAVAILABLE_FAQ: FaqCategoryItem = {
  id: "smartphone-operation-unavailable-faq",
  question: "スマートフォンで使用する際、画面は表示されるが操作ができない",
  Answer,
};
